import { connect } from "react-redux";
import { connect as formikConnect } from "formik";
import { isCompanyPage as isCompanyPageSelector } from "selectors/location";

import Details from "./Details";

const mapStateToProps = (state) => ({
  isCompanyPage: isCompanyPageSelector(state),
  portfolios: state.portfolioNames,
});

export default connect(mapStateToProps)(formikConnect(Details));
